import { useState, type Dispatch, type SetStateAction } from 'react';
import useIsComponentMounted from '../useIsComponentMounted/useIsComponentMounted';
import type { UseStateIfMountedParamResponse, UseStateIfMountedParams } from './types';

/**
 * Like React's [useState](https://reactjs.org/docs/hooks-reference.html#usestate)
 * but it makes sure the component that uses this hook is mounted when updating state
 *
 * @param {any} initialValue
 * @returns {[any, Diapatch<any>]} an array of 2 items
 *
 * the first is the current state, the second is a function that enables
 * updating the state if the component is not mounted
 */

const useStateIfMounted = <S>(
  initialValue?: UseStateIfMountedParams<S>
): UseStateIfMountedParamResponse<S> => {
  const isComponentMounted = useIsComponentMounted();

  const [state, setState] = useState<S>(initialValue as S);

  const newSetState: Dispatch<SetStateAction<S>> = value => {
    if (isComponentMounted.current) {
      setState(value);
    }
  };

  return [state, newSetState];
};

export default useStateIfMounted;
